<section class="flex min-h-0 flex-1 flex-col px-3 py-3">
  @if (!access().hasUpdateAccess) {
    <div class="flex flex-1 flex-col items-center justify-center gap-3 rounded-2xl border border-[#ece4f3] bg-[#faf7fc] px-4 py-10 text-center">
      <button
        type="button"
        class="rounded-lg border border-[#ece4f3] px-4 py-2 text-sm font-medium text-[#5a2f6b]"
        (click)="backToList()"
      >
        {{ "mobile.voiceReport.workflow.backToList" | translate }}
      </button>
    </div>
  } @else {
  @switch (step()) {
    @case ("recorder") {
      <mobile-voice-report-recorder
        [contextLabel]="missionLabel()"
        (finished)="onRecordingFinished($event)"
        (recordError)="onRecordError($event)"
      />
    }
    @case ("processing") {
      <mobile-voice-report-recorder
        [contextLabel]="missionLabel()"
        [externalPhase]="recorderPhase() ?? 'processing'"
      />
    }
    @case ("validation") {
      <mobile-voice-report-validation
        [reportHtml]="reportHtml()"
        [tasks]="tasks()"
        [isSubmitting]="isSubmitting()"
        (validated)="onValidated($event)"
      />
    }
    @case ("error") {
      <div class="flex flex-1 flex-col items-center justify-center gap-4 rounded-2xl border border-destructive/20 bg-destructive/5 px-4 py-10 text-center">
        <span class="material-icons text-[40px] text-destructive" aria-hidden="true">error_outline</span>
        <p class="text-sm text-destructive">{{ errorMessage() }}</p>
        <div class="flex w-full max-w-xs flex-col gap-2">
          <button
            type="button"
            class="rounded-lg bg-[#5a2f6b] px-4 py-2 text-sm font-semibold text-white"
            (click)="retryRecorder()"
          >
            {{ "common.retry" | translate }}
          </button>
          <button
            type="button"
            class="rounded-lg border border-[#ece4f3] px-4 py-2 text-sm font-medium text-[#5a2f6b]"
            (click)="backToList()"
          >
            {{ "mobile.voiceReport.workflow.backToList" | translate }}
          </button>
        </div>
      </div>
    }
  }
  }
</section>
